import {
  cloneVNode,
  defineComponent,
  isVNode,
  provide,
  reactive,
  toRef,
} from 'vue'
import { flattedChildren } from '@pit-element-plus/utils'
import ElTooltip from '@pit-element-plus/components/tooltip'
import { useNamespace } from '@pit-element-plus/hooks'
import ElAvatar from './avatar.vue'
import { avatarGroupContextKey } from './constants'
import { avatarGroupProps } from './avatar-group-props'

export default defineComponent({
  name: 'ElAvatarGroup',
  props: avatarGroupProps,
  setup(props, { slots }) {
    const ns = useNamespace('avatar-group')

    provide(
      avatarGroupContextKey,
      reactive({
        size: toRef(props, 'size'),
        shape: toRef(props, 'shape'),
      })
    )

    return () => {
      const avatars = flattedChildren(slots.default?.() ?? [])
      let visibleAvatars = avatars

      const showCollapseAvatar =
        props.collapseAvatars && avatars.length > props.maxCollapseAvatars

      if (showCollapseAvatar) {
        visibleAvatars = avatars.slice(0, props.maxCollapseAvatars)
        const hiddenAvatars = avatars.slice(props.maxCollapseAvatars)

        visibleAvatars.push(
          <ElTooltip
            popperClass={props.popperClass}
            popperStyle={props.popperStyle}
            placement={props.placement}
            effect={props.effect}
            disabled={!props.collapseAvatarsTooltip}
          >
            {{
              default: () => (
                <ElAvatar
                  size={props.size}
                  shape={props.shape}
                  class={props.collapseClass}
                  style={props.collapseStyle}
                >
                  + {hiddenAvatars.length}
                </ElAvatar>
              ),
              content: () => (
                <div class={ns.e('collapse-avatars')}>
                  {hiddenAvatars.map((node, idx) =>
                    isVNode(node)
                      ? cloneVNode(node, { key: node.key ?? idx })
                      : node
                  )}
                </div>
              ),
            }}
          </ElTooltip>
        )
      }

      return <div class={ns.b()}>{visibleAvatars}</div>
    }
  },
})
